/**
 * @generated SignedSource<<e900f4570394e50ed89a347705458fed>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type assetLibraryQueriesCreateAIAssetLibraryCategoryMutation$variables = {
  name: string;
  sortOrder: number;
};
export type assetLibraryQueriesCreateAIAssetLibraryCategoryMutation$data = {
  readonly createAIAssetLibraryCategory: {
    readonly createdDate: string;
    readonly id: string;
    readonly modifiedDate: string;
    readonly name: string;
    readonly sortOrder: number;
  };
};
export type assetLibraryQueriesCreateAIAssetLibraryCategoryMutation = {
  response: assetLibraryQueriesCreateAIAssetLibraryCategoryMutation$data;
  variables: assetLibraryQueriesCreateAIAssetLibraryCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sortOrder"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "sortOrder",
        "variableName": "sortOrder"
      }
    ],
    "concreteType": "AIAssetLibraryCategoryDTO",
    "kind": "LinkedField",
    "name": "createAIAssetLibraryCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sortOrder",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedDate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assetLibraryQueriesCreateAIAssetLibraryCategoryMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "assetLibraryQueriesCreateAIAssetLibraryCategoryMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "839d16f9be3037dd18351e7666363037",
    "id": null,
    "metadata": {},
    "name": "assetLibraryQueriesCreateAIAssetLibraryCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation assetLibraryQueriesCreateAIAssetLibraryCategoryMutation(\n  $name: String!\n  $sortOrder: Int!\n) {\n  createAIAssetLibraryCategory(name: $name, sortOrder: $sortOrder) {\n    id\n    name\n    sortOrder\n    createdDate\n    modifiedDate\n  }\n}\n"
  }
};
})();

(node as any).hash = "dabb3202ce75d8ceecded090c3cecd14";

export default node;
